module.exports = __webpack_public_path__ + "img/wz.13c07b57.png";